import { useAtomValue } from 'jotai/utils';
import PageSection from '../page-section';
import './index.css';
import announcementsAtom from '../../data/atoms/announcements';
import { faCircleExclamation, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Viewport({ children, className }) {

  return (
    <div id="app" className={className}>
      {children}
    </div>
  )
}

function AppBar({ children, bordered }) {

  const getClass = () => {
    const classNames = []
    if (bordered === true) classNames.push('bordered');
    return classNames.join(' ');
  };

  return (
    <div id="app-bar" className={getClass()}>
      {children}
    </div>
  )
}

function AppAnnouncements() {
  const { running, error, data: announcements } = useAtomValue(announcementsAtom);

  if (running || error || !announcements || announcements.data.length === 0) return null;

  return (
    <PageSection id="app-announcements" type="dark">
      {
        announcements.data.map((announcement, index) => (
          <div key={index} className={`announcement-container announcement-container-${announcement.type}`}>
            <div className="announcement-summary">
              <FontAwesomeIcon icon={announcement.type === 'info' ? faCircleInfo : faCircleExclamation} />
              <div>{announcement.summary}</div>
            </div>
            <div className="announcement-detail">{announcement.detail}</div>
          </div>
        ))}
    </PageSection>
  )
}

function AppSidebar({ children, bordered }) {

  const getClass = () => {
    const classNames = []
    if (bordered === true) classNames.push('bordered');
    return classNames.join(' ');
  };

  return (
    <div id="app-sidebar" className={getClass()}>
      {children}
    </div>
  )
}

function AppContent({ children }) {

  return (
    <div id="app-content">
      {children}
    </div>
  )
}

function ContentSidebar({ children, bordered, slim }) {

  const getClass = () => {
    const classNames = ['content-sidebar']
    if (bordered === true) classNames.push('bordered');
    if (slim === true) classNames.push('slim');
    return classNames.join(' ');
  };

  return (
    <div className={getClass()}>
      {children}
    </div>
  )
}

function ContentMenu({ children, bordered }) {

  const getClass = () => {
    const classNames = ['content-menu']
    if (bordered === true) classNames.push('bordered');
    return classNames.join(' ');
  };

  return (
    <div className={getClass()}>
      {children}
    </div>
  )
}

function ContentContainer({ children, responsive, padded, scrollable }) {

  const getClass = () => {
    const classNames = ['content-container']
    if (scrollable === true) classNames.push('scrollable');
    if (padded === true) classNames.push('padded');
    if (responsive === true) classNames.push('responsive');
    return classNames.join(' ');
  };

  return (
    <div className={getClass()} tabIndex={-1}>
      {children}
    </div>
  )
}


export { Viewport, AppBar, AppSidebar, AppContent, ContentSidebar, ContentMenu, ContentContainer, AppAnnouncements }
